var exports = {
  "my": "FeedPostEmbed.module__avatar___TkJzOT",
  "rf": "FeedPostEmbed.module__body___TkJzOT",
  "Qq": "FeedPostEmbed.module__text___TkJzOT",
  "Sl": "FeedPostEmbed.module__image___TkJzOT",
};

module.exports = exports;
